<div class="content">
  <div class="content-card filters">
    <div class="top">
      <div class="top__left">
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
          <button id="worker-delegation-list-create-button" mat-raised-button color="primary" (click)="openModal()">{{ 'DL-CreateDelegation' | translate }}</button>
          @if (isUserSupervisor) {
            <button id="worker-delegation-list-actions-button" mat-raised-button color="accent" [matMenuTriggerFor]="menu">{{ 'DL-Actions' | translate }}</button>
          }
        </div>
        <mat-menu #menu="matMenu">
          <span matTooltip="{{ 'DL-AcceptDelegationsTooltip' | translate }}" [matTooltipDisabled]="isAcceptDelegationButtonEnabled()">
            <button
              id="worker-delegation-list-accept-selected-button"
              mat-menu-item
              [visibleWithPermissions]="['ManageWorkerDelegations', 'ManageMyDelegations', 'Supervisor', 'FullDelegationsManagement', 'HRDelegationManagement']"
              [disabled]="!isAcceptDelegationButtonEnabled()"
              (click)="acceptSelectedDelegations()"
              >
              <span>{{ 'DL-AcceptDelegations' | translate }}</span>
            </button>
          </span>
          <span matTooltip="{{ 'DL-RejectDelegationsTooltip' | translate }}" [matTooltipDisabled]="isRejectDelegationButtonEnabled()">
            <button
              id="worker-delegation-list-reject-selected-button"
              mat-menu-item
              [visibleWithPermissions]="['ManageWorkerDelegations', 'ManageMyDelegations', 'Supervisor', 'FullDelegationsManagement', 'HRDelegationManagement']"
              [disabled]="!isRejectDelegationButtonEnabled()"
              (click)="rejectSelectedDelegations()"
              >
              <span>{{ 'DL-RejectDelegations' | translate }}</span>
            </button>
          </span>
        </mat-menu>
      </div>
      <div class="top__right">
        <button (click)="resetFilters()" class="top__button top__button-clear">
          <mat-icon>close</mat-icon>
          {{ 'Reset' | translate }}
        </button>
        <button (click)="toggleFiltersPanel()" class="top__button top__button-filter">
          <mat-icon>filter_alt</mat-icon>
          {{ 'Filter' | translate }}
        </button>
      </div>
    </div>
    @if (areFiltersExpanded) {
      <app-worker-delegation-list-filters
        [formGroup]="filtersFormGroup"
        (filterGridData)="filterData()"
      ></app-worker-delegation-list-filters>
    }
  </div>
  <div class="table-wrapper custom-table">
    <mat-table
      #table
      matSort
      matSortActive="lastName"
      matSortDirection="desc"
      matSortDisableClear
      [dataSource]="dataSource.workerDelegations$ | async"
      >
      @if (isUserSupervisor) {
        <ng-container matColumnDef="select" sticky>
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              appearance="outline"
              (change)="$event ? masterToggle() : null"
              [checked]="dataSource.selection.hasValue() && isAllSelected()"
              [indeterminate]="dataSource.selection.hasValue() && !isAllSelected()"
              [matTooltip]="'SelectAll' | translate"
              matTooltipPosition="above"
              >
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? dataSource.selection.toggle(row) : null"
              [checked]="dataSource.selection.isSelected(row)"
              >
            </mat-checkbox>
          </mat-cell>
        </ng-container>
      }
      <ng-container matColumnDef="client">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'DL-Client' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.Client" matTooltipPosition="above"
          ><span>{{ element.Client }}</span></mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="startDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-StartDate' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.StartDate | date : 'yyyy-MM-dd' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="endDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-EndDate' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.EndDate | date : 'yyyy-MM-dd' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-Status' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.Status }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="organizationalUnit">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ 'DL-OrganizationalUnit' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" [matTooltip]="element.OrganizationalUnit" matTooltipPosition="above"
            ><span>{{ element.OrganizationalUnit }}</span></mat-cell
            >
          </ng-container>
          <ng-container matColumnDef="createdOn">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'DL-CreatedOn' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.CreatedOn | date : 'yyyy-MM-dd' }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="destination">
            <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
              {{ 'DL-Destination' | translate }}
              <app-table-header-sort></app-table-header-sort>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.Destination" matTooltipPosition="above"
              ><span>{{ element.Destination }}</span></mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="acceptedBy">
              <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                {{ 'DL-UpdatedBy' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" [matTooltip]="element.AcceptedBy" matTooltipPosition="above"
                ><span>{{ element.AcceptedBy }}</span></mat-cell
                >
              </ng-container>
              <ng-container matColumnDef="acceptedOn">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                  {{ 'DL-AcceptedOn' | translate }}
                  <app-table-header-sort></app-table-header-sort>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">{{ element.AcceptedOn | date : 'yyyy-MM-dd' }}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="actions" stickyEnd>
                <mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <button id="worker-delegation-list-details-button" mat-icon-button (click)="openModal(element.Id, element.AuthServerUserId)">
                    @if (isDelegationInEditMode(element)) {
                      <mat-icon>create</mat-icon>
                    }
                    @if (!isDelegationInEditMode(element)) {
                      <mat-icon>pageview</mat-icon>
                    }
                  </button>
                  @if (isSendToApprovalButtonVisible(element)) {
                    <button id="worker-delegation-list-send-to-approval-button"
                      [visibleWithPermissions]="['ManageWorkerDelegations', 'ManageMyDelegations', 'Supervisor', 'FullDelegationsManagement', 'HRDelegationManagement']"
                      mat-icon-button
                      (click)="sendToApproval(element.Id)"
                      [matTooltip]="'SendToApproval' | translate"
                      matTooltipPosition="above"
                      >
                      <mat-icon>send</mat-icon>
                    </button>
                  }
                  @if (isDeleteButtonEnabled(element)) {
                    <button id="worker-delegation-list-delete-button"
                      [visibleWithPermissions]="['ManageWorkerDelegations', 'ManageMyDelegations', 'Supervisor', 'FullDelegationsManagement', 'HRDelegationManagement']"
                      mat-icon-button
                      (click)="deleteDelegation(element.Id)"
                      >
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                  @if (isAcceptDelegationButtonVisible(element)) {
                    <button id="worker-delegation-list-accept-button"
                      mat-icon-button
                      (click)="acceptSingleDelegation(element.Id)"
                      [visibleWithPermissions]="['ManageWorkerDelegations', 'Supervisor', 'FullDelegationsManagement', 'HRDelegationManagement']"
                      [matTooltip]="'AcceptDelegation' | translate"
                      matTooltipPosition="above"
                      >
                      <mat-icon>thumb_up_alt</mat-icon>
                    </button>
                  }
                  @if (isRejectDelegationButtonVisible(element)) {
                    <button id="worker-delegation-list-reject-button"
                      mat-icon-button
                      (click)="rejectSingleDelegation(element.Id)"
                      [visibleWithPermissions]="['ManageWorkerDelegations', 'Supervisor', 'FullDelegationsManagement', 'HRDelegationManagement']"
                      [matTooltip]="'RejectDelegation' | translate"
                      matTooltipPosition="above"
                      >
                      <mat-icon>thumb_down_alt</mat-icon>
                    </button>
                  }
                  @if (isSettleDelegationButtonEnabled(element)) {
                    <button 
                      id="worker-delegation-list-settle-button"
                      [visibleWithPermissions]="[
                        'AccountingDelegationManagement',
                        'AccountingDelegationManagementAllAccess',
                        'HRDelegationManagement',
                        'ManageMyDelegations',
                        'ManageWorkerDelegations',
                        'Supervisor',
                        'FullDelegationsManagement'
                      ]"
                      [matTooltip]="'DelegationSettlement' | translate"
                      mat-icon-button
                      (click)="onSettleDelegationClick(element)"
                      >
                      <mat-icon> account_balance_wallet </mat-icon>
                    </button>
                  }
                  @if (isSettlementCorrectionButtonEnabled(element)) {
                    <button
                      id="worker-delegation-list-correction-button"
                      [visibleWithPermissions]="['ManageWorkerDelegations', 'ManageMyDelegations', 'Supervisor', 'FullDelegationsManagement', 'HRDelegationManagement']"
                      [matTooltip]="'DelegationSettlementCorrection' | translate"
                      mat-icon-button
                      (click)="onSettlementCorrectionClick(element)"
                      >
                      <mat-icon> warning </mat-icon>
                    </button>
                  }
                  @if (isAcceptDelegationCostsAsAccountingButtonVisible(element)) {
                    <button
                      id="worker-delegation-list-accept-as-accounting-button"
                      mat-icon-button
                      (click)="acceptSingleDelegationCostsAsAccounting(element)"
                      [visibleWithPermissions]="['AccountingDelegationManagement', 'AccountingDelegationManagementAllAccess', 'FullDelegationsManagement']"
                      >
                      <mat-icon [matTooltip]="'AcceptDelegationCostsAsAccounting' | translate">arrow_downward</mat-icon>
                    </button>
                    <button
                      id="worker-delegation-list-settle-as-accounting-button"
                      [visibleWithPermissions]="['ManageWorkerDelegations', 'ManageMyDelegations', 'Supervisor', 'HRDelegationManagement']"
                      [matTooltip]="'DelegationSettlement' | translate"
                      mat-icon-button
                      (click)="onSettleDelegationClick(element)"
                      >
                      <mat-icon> account_balance_wallet </mat-icon>
                    </button>
                  }
                  @if (isDelegationCorrection(element)) {
                    <button
                      id="worker-delegation-list-settle-correction-button"
                      [visibleWithPermissions]="['AccountingDelegationManagement', 'AccountingDelegationManagementAllAccess', 'FullDelegationsManagement']"
                      [matTooltip]="'DelegationSettlement' | translate"
                      mat-icon-button
                      (click)="onSettleDelegationClick(element)"
                      >
                      <mat-icon> account_balance_wallet </mat-icon>
                    </button>
                  }
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            </mat-table>
          </div>
          <mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"> </mat-paginator>
        </div>
